import { FC } from "react"
import classNames from "classnames"
import { Icon, IconProps, IconColor } from "@/components/shared/Icon"
import "./index.scss"

interface CheckboxProps {
   label: string
   checked: boolean
   onChange: (checked: boolean) => void
   disabled?: boolean
   className?: string
   id?: string
   iconColor?: IconColor
   iconName?: IconProps["name"]
}

const Checkbox: FC<CheckboxProps> = ({
   label,
   checked,
   onChange,
   disabled = false,
   className,
   id,
   iconColor = IconColor.JET_BLACK,
   iconName,
}) => {
   return (
      <div
         className={classNames("checkbox", className, {
            ["checkbox--disabled"]: disabled,
         })}
      >
         <input
            type="checkbox"
            id={id}
            checked={checked}
            {...(!disabled && { onChange: () => onChange(!checked) })}
            disabled={disabled}
            className="checkbox__input"
         />
         <label
            htmlFor={id}
            className="checkbox__label"
         >
            <span className="checkbox__box">
               <Icon
                  name="checkmark"
                  color={
                     !disabled ? IconColor.HONOLULU_BLUE : IconColor.COOL_GRAY
                  }
                  size="14"
               />
            </span>
            {iconName && (
               <span className="checkbox__label-icon">
                  <Icon
                     name={iconName}
                     size="12"
                     color={!disabled ? iconColor : IconColor.SILVER}
                  />
               </span>
            )}
            {label}
         </label>
      </div>
   )
}

export default Checkbox
